<div class="modal1Main">
  <div class="modalHeader" #header>
    <span class="title">
      Lobby Filters
    </span>
    <button class="closepop float-right"  mat-dialog-close><i class="zmdi zmdi-close"></i></button>
  </div>
  <div class="modalBody lobby-filter" appSameHeight className="sameHeightDesktop" [ngStyle]="{'max-height':(!isMobile)?'calc(100vh - '+(header.offsetHeight + 5) + 'px - 50px)':'auto'}">
    <div class="header">
      <div>
        <mat-slide-toggle
          [(ngModel)]="checked"
          id="filterCheck"
          [color]="color"
          (change)="changed()">
            Filter {{checked ? 'ON' : 'OFF'}}
        </mat-slide-toggle>
      </div>
      <div>
        <mat-form-field id="search-opt">
          <input type="text" matInput [(ngModel)]="search" placeholder="Search...">
        </mat-form-field>
      </div>
      <div>
        Entrants: <i class="fas fa-arrow-up" (click)="filters.entrant_orderby = (filters.entrant_orderby == 'ASC')?'DESC':'ASC'" [ngClass]="{'fa-arrow-up':filters.entrant_orderby == 'ASC', 'fa-arrow-down':filters.entrant_orderby == 'DESC', 'red':filters.entrant_orderby == 'ASC', 'green':filters.entrant_orderby == 'DESC'}"></i> Buy-In: <i class="fas fa-arrow-up" (click)="filters.buy_in_orderby = (filters.buy_in_orderby == 'ASC')?'DESC':'ASC'" [ngClass]="{'fa-arrow-up':filters.buy_in_orderby == 'ASC', 'fa-arrow-down':filters.buy_in_orderby == 'DESC', 'red':filters.buy_in_orderby == 'ASC', 'green':filters.buy_in_orderby == 'DESC'}"></i>
      </div>
    </div>
    <div class="halfDesktop" [ngClass]="{'sameHeightDesktop':!isMobile}">
      <h3 mat-subheader class="firstHeader">Sports</h3>
      <div *ngFor="let game of games;let i = index;" class="gameCheckbox">
        <mat-checkbox (change)="selectSport(game.id)" [checked]="!(filters == null || filters.game_id == null || (filters.game_id.split(',').indexOf('all') == -1 && filters.game_id.split(',').indexOf(game.id) == -1))"><div class="checkboxLabel">{{game.name.toUpperCase()}}</div></mat-checkbox>
      </div>
    </div>
    <div class="halfDesktop noRight" [ngClass]="{'sameHeightDesktop':!isMobile}">
      <h3 mat-subheader>Contests</h3>
      <div class="contestCheckbox"><mat-checkbox (change)="setContest('tiers',$event)" [checked]="contests.indexOf('tiers') > -1"><div class="checkboxLabel">Classic Tiers</div></mat-checkbox></div>
      <div class="contestCheckbox"><mat-checkbox (change)="setContest('rankem',$event)" [checked]="contests.indexOf('rankem') > -1"><div class="checkboxLabel">Rank'Em</div></mat-checkbox></div>
      <div class="contestCheckbox"><mat-checkbox (change)="setContest('bestball',$event)" [checked]="contests.indexOf('bestball') > -1"><div class="checkboxLabel">Best Ball</div></mat-checkbox></div>
      <div class="contestCheckbox"><mat-checkbox (change)="setContest('snake',$event)" [checked]="contests.indexOf('snake') > -1"><div class="checkboxLabel">Snake Draft</div></mat-checkbox></div>
      <div class="contestCheckbox"><mat-checkbox (change)="setContest('gpp',$event)" [checked]="contests.indexOf('gpp') > -1"><div class="checkboxLabel">GPP Tournament</div></mat-checkbox></div>
      <div class="contestCheckbox"><mat-checkbox (change)="setContest('multi',$event)" [checked]="contests.indexOf('multi') > -1"><div class="checkboxLabel">Multi-Draft Tournament</div></mat-checkbox></div>
      <div class="contestCheckbox"><mat-checkbox (change)="setContest('playoffs',$event)" [checked]="contests.indexOf('playoffs') > -1"><div class="checkboxLabel">Playoffs</div></mat-checkbox></div>
    </div>
    <div class="halfDesktop" style="margin-top:10px;">
      <h3 mat-subheader>Entrants</h3>
      <mat-form-field class="filterInput">
        <mat-label>Minimum</mat-label>
        <input type="number" matInput placeholder="0" [(ngModel)]="minEntrants">
      </mat-form-field>
      <mat-form-field class="filterInput">
        <mat-label>Maximum</mat-label>
        <input type="number" matInput placeholder="200000" [(ngModel)]="maxEntrants">
      </mat-form-field>
    </div>
    <div class="halfDesktop noRight" style="margin-top:10px;">
      <h3 mat-subheader>Buy-In</h3>
      <mat-form-field class="filterInput">
          <mat-label>Minimum</mat-label>
          <input type="number" matInput placeholder="0" [(ngModel)]="minBuyin">
        </mat-form-field>
        <mat-form-field class="filterInput">
          <mat-label>Maximum</mat-label>
          <input type="number" matInput placeholder="10000" [(ngModel)]="maxBuyin">
        </mat-form-field>
    </div>
    <div class="actionBtns">
      <button mat-button class="saveBtn" [disabled]="!checked" (click)="saveFilters()">Use Filter</button>
    </div>
  </div>
</div>